export default {
  strings: {
    nav: {
      home: "Home",
      services: "Services",
      personal: "Personal Support",
      about: "About",
      packages: "Packages",
      faq: "FAQ",
      contact: "Contact",
      book: "Book a Consultation",
    },
    common: {
      book: "Book a Consultation",
      quote: "Request a Quote",
      viewServices: "View Services",
    },
    whatsapp: {
      label: "Chat on WhatsApp",
      prefill: "Hello VCK Business Lab! I'd like to ask about your services.",
    },
    footer: {
      tagline: "Elevated Virtual Support for Modern Business",
      blurb:
        "Dependable, confidential, and detail-oriented virtual administrative support — delivered 100% virtually to clients across Canada, the United States, Europe, and internationally.",
      explore: "Explore",
      services: "Services",
      ownerLogin: "Owner Login",
      rights: "VCK Business Lab. All rights reserved.",
      virtual: "100% Virtual · Worldwide",
      quote: "Request a Quote",
    },
    cta: {
      overline: "Let Us Handle the Details.",
      title: "Spend less time on administration and more time moving your business forward.",
      book: "Book a Consultation",
      quote: "Request a Quote",
    },
    home: {
      heroOverline: "VCK Business Lab · 100% Virtual · Worldwide",
      heroLine1: "Professional Virtual Support",
      heroLine2: "for Business & Everyday Life.",
      heroSub:
        "Administrative, business and multilingual support for companies, professionals, individuals and newcomers — delivered 100% virtually across Canada and worldwide.",
      heroStats: [
        { stat: "100%", label: "Virtual delivery, anywhere" },
        { stat: "Worldwide", label: "Canada · US · Europe · beyond" },
        { stat: "Boutique", label: "Confidential, one-to-one support" },
      ],
      extOverline: "An Extension of Your Business",
      extTitle: "Dependable support, without the full-time hire.",
      extCopy:
        "VCK Business Lab works as a seamless extension of your business — providing dependable, confidential, and detail-oriented administrative support without the cost or commitment of hiring a full-time employee.",
      extPoints: [
        { title: "Dependable", text: "Consistent, reliable support you can plan around." },
        { title: "Confidential", text: "Your business information is handled with strict confidentiality and reasonable safeguards." },
        { title: "Detail-Oriented", text: "Every task handled carefully, to a high standard." },
      ],
      svcOverline: "Services",
      svcTitle: "Everything on your desk, quietly taken care of.",
      svcCopy: "Our areas of support — delivered virtually and tailored to the way you work and live.",
      svcViewAll: "Explore All Services",
      svcViewDetails: "View details",
      splitOverline: "Support Designed Around You",
      splitTitle: "Two paths. One standard of care.",
      splitCopy: "Whether you're running a business or building a new life, VCK meets you where you are.",
      splitBizTitle: "Business Services",
      splitBizText:
        "Virtual administrative, executive, multilingual, document, project, and website support for companies, entrepreneurs, and professionals worldwide.",
      splitBizPoints: ["Administrative & executive support", "Translation & multilingual communication", "Documents, projects & websites"],
      splitBizCta: "Explore Business Services",
      splitPerTitle: "Personal & Newcomer Support",
      splitPerText:
        "Patient, confidential support for individuals, families, and newcomers to Canada — everyday tasks handled in your language.",
      splitPerPoints: ["Language & communication assistance", "Insurance, banking & utilities help", "Housing, schools & everyday admin"],
      splitPerCta: "Explore Personal Support",
      stepsOverline: "How It Works",
      stepsTitle: "From first call to full focus, in four steps.",
      whyOverline: "Why Choose VCK",
      whyTitle: "The standard your business deserves.",
      whyCopy: "More than task completion — a professional partnership built on trust, precision, and discretion.",
      whoOverline: "Who We Work With",
      whoTitle: "Trusted by the people who keep business moving.",
      testOverline: "Kind Words",
      testTitle: "Client stories.",
      testLaunch: "We're currently welcoming our first Founding Pilot Clients. Client experiences and case studies will be added as VCK grows.",
      packOverline: "Ongoing Support Plans",
      packTitle: "Monthly support, shaped around you.",
      packCopy:
        "Customizable monthly packages in USD — never rigid subscriptions. Final pricing is confirmed together after a short consultation.",
      packViewAll: "View Packages",
      packIncluded: "See what's included",
      packGlobalTitle: "Global Priority",
      packGlobalText:
        "International, multilingual, extended-hour, or higher-volume support — fully customized monthly arrangements with custom workflows and discounted emergency rates.",
      packGlobalBtn: "Request Custom Quote",
      faqOverline: "Common Questions",
      faqTitle: "Answers, before you ask.",
      faqViewAll: "View All FAQs",
      loyaltyText:
        "Long-term clients earn up to 36 complimentary support hours, priority benefits, and a VCK welcome package.",
      loyaltyCta: "Explore Loyalty Rewards",
    },
    services: {
      overline: "Services & Pricing",
      line1: "Services Designed Around",
      line2: "You.",
      intro:
        "From everyday administration to multilingual communication and urgent international support, VCK Business Lab provides flexible multilingual support for businesses, professionals, newcomers, international students, and international clients.",
      languages: "English | Українська | العربية | Other Languages",
      worldwide: "Serving Clients Worldwide • 100% Virtual",
      showLess: "Show Less",
      pricing: "Pricing",
      plansOverline: "Ongoing Support Plans",
      plansTitle: "Monthly support, shaped around you.",
      plansCopy:
        "These are not rigid subscriptions — every plan can be customized to your hours, services, languages, and priorities.",
      disOverline: "Flexible Pricing for Every Business",
      disQuote:
        "“Prices shown are starting rates in USD. Final pricing depends on the complexity, language combination, turnaround time, required expertise, volume, and service requirements. Monthly packages and project-based pricing are available.”",
      disNote: "No long-term commitment required unless agreed upon in a service contract.",
    },
    packages: {
      availabilityNote: "Prices shown are starting prices, and all services are subject to availability. Scope, deliverables, deadlines, fees, and revisions are confirmed in a written quote or agreement.",
      overline: "Packages",
      line1: "Support, scaled to",
      line2: "your workload.",
      intro:
        "Every engagement uses tailored, starting-from pricing — finalized together after a short consultation, so you only ever pay for the support you actually need. No pressure to purchase; begin with a quote.",
      note:
        "These are not rigid subscriptions — every plan can be customized to your hours, services, languages, and priorities.",
      mostRequested: "Most Requested",
      startingFrom: "Starting From",
      tailored: "Tailored",
      requestQuote: "Request a Quote",
      quoteNote: "No online checkout — once scope and pricing are confirmed, we send you a secure payment link directly.",
      compareOverline: "Compare Packages",
      compareTitle: "Find your fit at a glance.",
      compareIncluded: "Included",
      disOverline: "Flexible Pricing for Every Business",
      disQuote:
        "“Prices shown are starting rates in USD. Final pricing depends on the complexity, language combination, turnaround time, required expertise, volume, and service requirements. Monthly packages and project-based pricing are available.”",
      disNote: "No long-term commitment required unless agreed upon in a service contract.",
      loyaltyOverline: "Client Loyalty Rewards",
      loyaltyTitle: "More Support. More Value. More Reasons to Stay.",
      loyaltyIntro:
        "At VCK Business Lab, we value long-term partnerships. When you choose an ongoing support plan, we'll thank you with complimentary support hours, priority benefits, and a VCK welcome gift.",
      bestValue: "Best Value",
      welcomeOverline: "A Little Something From VCK",
      welcomeTitle: "Every new long-term client should feel welcomed.",
      welcomeText:
        "Eligible clients receive a complimentary VCK Welcome Package, thoughtfully prepared as a thank-you for choosing us as your business support partner.",
      welcomeNote: "No additional charge — just our way of saying welcome to VCK.",
      welcomeInclude: "Your package may include",
      welcomeItems: ["Premium desk essentials", "Business accessories", "VCK-branded items", "A personalized welcome gift"],
      bonusOverline: "Your Bonus Hours, Your Choice",
      bonusTitle: "Use your additional hours when you need that extra helping hand.",
      bonusText: "Complimentary hours can be used toward eligible VCK services, including:",
      builtOverline: "Built Around Your Business",
      builtTitle: "Not sure which package is right for you?",
      builtText: "We can create a support plan based on your workload, languages, time zone, and business needs.",
      builtBook: "Book a Free Consultation",
      builtOr: "or",
      builtQuote: "Request Your Personalized Quote",
      welcomeLine: "Welcome to VCK Business Lab",
      welcomeTagline: "Global support · Multilingual expertise · A business partner you can rely on",
      referOverline: "Referral Program",
      referTitle: "Share VCK. Earn Complimentary Support.",
      referIntro:
        "Love working with VCK Business Lab? Refer another business and receive complimentary support hours when they become a VCK client.",
      referSteps: [
        {
          title: "Refer a Business",
          text: "Introduce VCK Business Lab to a business, professional, or entrepreneur who could benefit from our services.",
        },
        { title: "They Join VCK", text: "Your referral signs an eligible VCK commitment package." },
        {
          title: "You Receive Free Hours",
          text: "Once their agreement begins, complimentary support hours are added to your account as our thank-you.",
        },
      ],
      referRewardsTitle: "Referral Rewards",
      referTiers: [
        { plan: "Referral signs a 1-Month Package", hours: "Receive 2 Complimentary Hours" },
        { plan: "Referral signs a 3-Month Package", hours: "Receive 5 Complimentary Hours" },
        { plan: "Referral signs a 6-Month Package", hours: "Receive 10 Complimentary Hours" },
        { plan: "Referral signs a 12-Month Package", hours: "Receive 20 Complimentary Hours" },
      ],
      referMoreTitle: "Refer More. Earn More.",
      referMoreText:
        "There is no need to stop at one referral. Refer multiple businesses and continue earning complimentary VCK support hours as eligible referrals become clients.",
      referMilestones: [
        { count: "3 successful referrals", reward: "Receive an additional 5 bonus hours" },
        { count: "5 successful referrals", reward: "Receive an additional 10 bonus hours" },
        { count: "10 successful referrals", reward: "Receive a special VCK Loyalty Reward plus additional complimentary support" },
      ],
      referThanksOverline: "A Thank-You for Growing With Us",
      referThanksText:
        "Our business grows through relationships, and we want our clients to benefit when they introduce VCK to others. Your complimentary referral hours can be used toward eligible services such as:",
      referServices: [
        "Virtual administrative support",
        "Executive support",
        "Multilingual business support",
        "Document and project services",
        "Translation services",
        "Other eligible VCK services",
      ],
      referCtaTitle: "Know a Business That Could Use VCK?",
      referCtaText: "Help another business discover reliable global support — and enjoy extra VCK hours on us.",
      referCtaBtn: "Refer a Business",
    },
    about: {
      overline: "About VCK",
      line1: "A boutique partner for the work",
      line2: "behind your work.",
      intro:
        "VCK Business Lab was created to provide businesses and professionals with dependable, organized, and high-quality virtual administrative support — delivered with the care of a boutique firm, not the distance of a large corporation.",
      storyOverline: "Why We Exist",
      storyTitle: "Created to give you your time back.",
      storyP1:
        "Routine administrative work quietly consumes the hours that matter most. VCK Business Lab exists to take that weight off your desk — making business operations easier with flexible, professional support, without the cost and commitment of hiring an additional full-time employee.",
      storyP2:
        "Professionalism, organization, communication, confidentiality, and attention to detail are not marketing words here — they are the working standard behind every inbox managed, document prepared, and meeting coordinated.",
      manOverline: "Our Principles",
      manTitle: "Three commitments, kept daily.",
      globalOverline: "Global Reach",
      globalTitle: "Wherever you do business, so do we.",
      globalCopy:
        "All services are delivered 100% virtually, allowing VCK to support clients seamlessly across time zones and borders.",
      regions: ["Canada", "United States", "Europe", "International"],
      valuesOverline: "Core Values",
      valuesTitle: "What you can expect, every time.",
      whoOverline: "Who We Work With",
      whoTitle: "Built for busy people and growing businesses.",
    },
    faqPage: {
      overline: "FAQ",
      line1: "Answers, before",
      line2: "you ask.",
      intro:
        "The questions clients ask most about working with VCK Business Lab. If yours isn't answered here, we're one message away.",
      calloutOverline: "Still Have a Question?",
      calloutTitle: "Let's talk it through — no obligation.",
      calloutText:
        "A complimentary introductory consultation is the easiest way to get answers specific to your business.",
      calloutBtn: "Book a Free Consultation",
    },
    contact: {
      overline: "Contact",
      line1: "Let's talk about",
      line2: "your workload.",
      intro:
        "Tell us what you'd like taken off your plate. Every inquiry receives a personal response within one business day.",
      consultTitle: "Book a Free Consultation",
      consultText:
        "Schedule a complimentary introductory consultation to discuss your business needs — no obligation, no pressure. We'll recommend the type and level of support that fits you best.",
      consultPoints: [
        "Introductory call at a time that suits you",
        "A tailored recommendation for your workload",
        "Zero obligation to proceed",
      ],
      consultBtn: "Book a Free Consultation",
      consultNote:
        "All services are delivered 100% virtually. Inquiries from international clients — across Canada, the United States, Europe, and beyond — are warmly welcome.",
      trackLabel: "I'm reaching out as",
      trackBusiness: "A Business",
      trackPersonal: "An Individual / Newcomer",
      trackRequired: "Please tell us whether you're reaching out as a business or an individual.",
      formTitle: "Send an Inquiry",
      formSub: "Request a quote or ask a question — we'll take it from there.",
      name: "Name",
      company: "Company",
      email: "Email",
      phone: "Phone",
      country: "Country",
      support: "Type of Support Needed",
      hours: "Estimated Hours per Week",
      preferred: "Preferred Contact Method",
      description: "Project Description",
      optional: "— optional",
      phName: "Your full name",
      phCompany: "Company or title",
      phEmail: "you@company.com",
      phPhone: "+1 (___) ___-____",
      phCountry: "Where you're based",
      phDescription: "Tell us about the tasks or projects you'd like support with…",
      selectService: "Select a service",
      selectHours: "Select an estimate",
      selectPreferred: "How should we reach you?",
      freeConsultation: "Free Consultation",
      customProject: "Custom Project",
      notSure: "Not sure yet",
      hoursOptions: ["1–5 hours", "5–10 hours", "10–20 hours", "20+ hours", "One-time project", "Not sure yet"],
      contactOptions: ["Email", "Phone", "Video call"],
      planPrefill: "I'd like to request a quote for the {name} package.",
      referralPrefill: "I'd like to refer a business to VCK Business Lab.",
      submit: "Send Inquiry",
      sending: "Sending…",
      successTitle: "Thank you — your inquiry has been received.",
      successText: "We'll respond within one business day. A confirmation email is on its way to you.",
      errorTitle: "Something went wrong sending your inquiry.",
      errorText: "Please try again in a moment.",
    },
    personal: {
      overline: "Personal & Newcomer Support",
      line1: "Everyday support for",
      line2: "life in a new country.",
      intro:
        "Moving to a new country — or simply managing a busy personal life — comes with letters, calls, forms, and appointments, often in a language that isn't your first. VCK Business Lab offers patient, confidential virtual support for individuals, families, and newcomers to Canada.",
      languages: "English | Українська | العربية",
      worldwide: "Serving Individuals & Families Worldwide • 100% Virtual",
      whoOverline: "Who This Is For",
      whoTitle: "Support for the moments that matter.",
      whoList: ["Newcomers to Canada", "Individuals & Families", "Seniors", "Students", "Busy Professionals", "Anyone with Limited English"],
      svcOverline: "How We Help",
      svcTitle: "Personal support, in your language.",
      svcCopy:
        "Support for the everyday tasks of settling in and staying organized — delivered virtually, patiently, and confidentially.",
      services: [
        {
          title: "Language Assistance",
          text: "Everyday letters, emails, forms, and phone calls — understood and answered in your language.",
          items: ["Understanding official letters & emails", "Help completing everyday forms", "Phone-call support in your language", "Everyday, non-certified translation"],
        },
        {
          title: "Insurance & Banking Communication",
          text: "Clear, confident communication with banks, insurers, and service providers.",
          items: ["Preparing for bank & insurance calls", "Understanding correspondence & statements", "Scheduling appointments", "Follow-up emails on your behalf"],
        },
        {
          title: "Utilities & Bills",
          text: "Getting connected and staying on top of monthly obligations.",
          items: ["Setting up internet, phone & utility accounts", "Understanding monthly bills", "Arranging service appointments", "Comparing plan options"],
        },
        {
          title: "Housing Support",
          text: "Calm, organized help through the rental process.",
          items: ["Communicating with landlords & property managers", "Scheduling viewings", "Understanding rental correspondence", "Move-in & move-out checklists"],
        },
        {
          title: "Schools & Family",
          text: "Support for your family's day-to-day coordination.",
          items: ["School registration support", "Parent–teacher communication", "Community program forms", "Children's activity scheduling"],
        },
        {
          title: "Everyday Administration",
          text: "The small tasks that quietly pile up — taken care of.",
          items: ["Appointment booking & reminders", "Personal document organization", "Resume & cover-letter formatting", "Calendar & schedule management"],
        },
      ],
      stepsOverline: "How It Works",
      stepsTitle: "Simple, from the very first message.",
      steps: [
        { title: "Tell Us", text: "Share what you need help with — in your own language, by message or a free consultation." },
        { title: "Confirm", text: "We confirm the scope and a clear starting price before any work begins." },
        { title: "We Handle It", text: "Calls, forms, emails, and arrangements taken care of — patiently and confidentially." },
        { title: "You Stay Informed", text: "Clear updates in your language, every step of the way." },
      ],
      disOverline: "Important to Know",
      disTitle: "Clear boundaries, by design.",
      disIntro:
        "VCK Business Lab provides administrative, organizational, and communication support only. We are careful — and transparent — about what we do not do.",
      disclaimers: [
        {
          title: "No Immigration Advice",
          text: "VCK Business Lab does not provide immigration advice or consulting, and does not prepare, review, or submit immigration applications. For immigration matters, please consult a Regulated Canadian Immigration Consultant (RCIC) or an immigration lawyer.",
        },
        {
          title: "No Legal, Financial, or Insurance Advice",
          text: "We do not provide legal, financial, insurance, tax, or medical advice. Our role is communication, organization, and administration — decisions always remain with you and your licensed professionals.",
        },
        {
          title: "Non-Certified Translation Only",
          text: "Translations offered under personal support are general, non-certified translations for everyday understanding. We do not provide certified, sworn, notarized, or court-accepted translations.",
        },
        {
          title: "The Right Professional, Always",
          text: "When your situation requires a licensed or regulated professional, we will always tell you — and help you find the right one.",
        },
      ],
      partnerOverline: "Post-Arrival Administrative & Language Support in Canada",
      partnerTitle: "We complement the professionals who bring you here.",
      partnerLine: "You help your clients get to Canada. VCK Business Lab helps support them once they arrive.",
      partnerText:
        "VCK Business Lab works alongside immigration consultants, education agencies, colleges, recruiters, and relocation companies — never in place of them.",
      partnerTypesLabel: "Who Refers to Us",
      partnerTypes: ["Immigration Consultants (RCIC) & Lawyers", "Education Agencies & Colleges", "Recruiters & Employers", "Relocation Companies", "Settlement & Community Organizations"],
      partnerWhyTitle: "Why partners refer to VCK",
      partnerWhy: [
        { title: "In Their Language", text: "Clients are supported in English, Ukrainian, Arabic, and other languages — nothing lost in translation." },
        { title: "Clear Boundaries", text: "We provide administrative and language support only — we never give immigration or regulated advice, so we complement your work, never compete with it." },
        { title: "Fast & Reliable", text: "Every referred client receives a response within one business day and a free introductory consultation." },
        { title: "Confidential by Default", text: "Client information is handled with strict confidentiality, with agreements available when needed." },
      ],
      partnerCta: "Discuss a Referral Partnership",
      ctaOverline: "You Don't Have to Figure It Out Alone.",
      ctaTitle: "Tell us what you need — in your own language.",
      ctaText: "A free introductory consultation is the easiest way to start. No obligation, no pressure.",
    },
  },
  data: null,
};
